module.exports = __webpack_public_path__ + "img/glogo214.3bfcdf64.png";